import TypoView from './Typo.view';

export default TypoView;
